export const CODESMITH_EXTENSION_EMBED_VALUE = "extension";
export const CODESMITH_EXTENSION_AUTH_MESSAGE =
  "codesmith-extension-auth-complete";

export function isCodesmithExtensionEmbed(
  value: string | string[] | undefined,
): boolean {
  return Array.isArray(value)
    ? value.includes(CODESMITH_EXTENSION_EMBED_VALUE)
    : value === CODESMITH_EXTENSION_EMBED_VALUE;
}

export function addCodesmithExtensionEmbed(path: string): string {
  const [pathAndQuery, hash] = path.split("#", 2);
  const separator = pathAndQuery.includes("?") ? "&" : "?";
  const embedded = `${pathAndQuery}${separator}embed=${CODESMITH_EXTENSION_EMBED_VALUE}`;
  return hash === undefined ? embedded : `${embedded}#${hash}`;
}
